<template>
  <header class="ngo-header">
    <div class="container ngo-logo-header px-2 align-items-center justify-content-between bg-white">
      <div class="h3-logo py-25">
        <router-link class="d-flex align-items-center" :to="`/ngo/${$route.params.id}`">
          <div class="d-flex align-items-center">
            <img height="60" :src="logo.logo" :alt="`شعار منظمة ${logo.name_ar}`" class="rounded" />

            <span style="max-width: 200px" class="text-center mx-1 text-body">
              {{ logo.name_ar }}
            </span>
          </div>
        </router-link>
      </div>
      <div class="h3-logo py-25">
        <router-link class="d-flex align-items-center" to="/">
          <img height="60" :src="require('@/assets/images/logo/header-logo.png')" alt="" />
        </router-link>
      </div>
    </div>
    <div class="nav_big_screen ngo-header-nav border_header">
      <nav class="container d-flex align-items-center justify-content-between">
        <ul class="nav-container my-1">
          <li>
            <router-link class="header-nav" to="/"> الرئيسية</router-link>
          </li>
          <li>
            <router-link class="header-nav" :to="{
              name: 'ngo-home',
              params: { id: this.$route.params.id },
            }">
              عن المنظمة</router-link>
          </li>

          <li>
            <router-link class="header-nav" :to="{
              name: 'activities',
              params: { id: this.$route.params.id },
            }">
              الأخبار</router-link>
          </li>
          <li>
            <router-link class="header-nav" :to="{
              name: 'ngo-donation',
              params: { id: this.$route.params.id },
            }">
              التبرع</router-link>
          </li>
          <li>
            <router-link class="header-nav" :to="{
              name: 'ngo-events',
              params: { id: this.$route.params.id },
            }">
              الفعاليات</router-link>
          </li>
          <li>
            <b-dropdown :class="{
              'active-dropdown':
                $route.path.includes('jobs') ||
                $route.path.includes('volunteer'),
            }" text="انضم إلينا" variant="flat-primary">
              <b-dropdown-item :to="{
                name: 'ngo-jobs',
                params: { id: this.$route.params.id },
              }">فرص العمل</b-dropdown-item>
              <hr class="m-0" />
              <b-dropdown-item :to="{
                name: 'ngo-volunteer',
                params: { id: this.$route.params.id },
              }">فرص تطوع</b-dropdown-item>
            </b-dropdown>
          </li>
          <li>
            <b-dropdown :class="{
              'active-dropdown':
                $route.path.includes('founders') ||
                $route.path.includes('admins'),
            }" text="فريق العمل" variant="flat-primary">
              <b-dropdown-item :to="{
                name: 'ngo-founders',
                params: { id: this.$route.params.id },
              }">
                المؤسسين</b-dropdown-item>
              <hr class="m-0" />

              <template v-if="logo.legalForm && logo.legalForm.name_ar === 'مؤسسة'">
                <b-dropdown-item :to="{
                  name: 'ngo-trustees',
                  params: { id: this.$route.params.id },
                }">
                  مجلس الأمناء</b-dropdown-item>
                <hr class="m-0" />
              </template>

              <b-dropdown-item v-else-if="logo.legalForm && logo.legalForm.name_ar === 'جمعية'" :to="{
                name: 'ngo-admins',
                params: { id: this.$route.params.id },
              }">مجلس الإدارة</b-dropdown-item>
              <!-- TODO : bring back excutives when ministry agrees to do so -->
              <!-- <hr class="m-0" /> -->
              <!-- <b-dropdown-item
                :to="{
                  name: 'ngo-excutives',
                  params: { id: this.$route.params.id },
                }"
                >الإدارة التنفيذية</b-dropdown-item
              > -->
            </b-dropdown>
          </li>
          <li>
            <router-link class="header-nav" :to="{
              name: 'ngo-contact-us',
              params: { id: this.$route.params.id },
            }">
              تواصل معنا</router-link>
          </li>
        </ul>
        <div class="d-flex">
          <a @click="searchModal = true" class="d-flex text-light align-items-center">
            <feather-icon size="18" icon="SearchIcon" class="mr-50" />
            <span>بحث عن منظمة</span>
          </a>
        </div>

        <ngo-search-modal v-model="searchModal" />
      </nav>
    </div>
    <header-small-screen-ngo></header-small-screen-ngo>
  </header>
</template>

<script>
import {
  BNav,
  BNavItem,
  BButton,
  BDropdown,
  BDropdownItem,
  BModal,
} from "bootstrap-vue";
import HeaderSmallScreenNgo from "./HeaderSmallScreenNgo.vue";
import { mapGetters } from "vuex";
import NgoSearchModal from "./NgoSearchModal.vue";
export default {
  components: {
    BNav,
    BNavItem,
    BButton,
    HeaderSmallScreenNgo,
    BDropdown,
    BDropdownItem,
    BModal,
    NgoSearchModal,
  },
  data() {
    return {
      searchModal: false,
    };
  },
  computed: {
    ...mapGetters("NgoHome", ["logo"]),
  },
};
</script>

<style lang="scss">
.ngo-header-nav {
  background-color: var(--primary);
  border: none;

  .nav-container {
    .dropdown-toggle {
      &:after {
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
      }
    }

    .active-dropdown {
      .dropdown-toggle {
        background-color: white;
        color: var(--primary);

        &:after {
          background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%234b4b4b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
        }
      }
    }

    .dropdown-toggle {
      color: white;
    }

    .header-nav {
      color: white;
    }

    .router-link-exact-active {
      background-color: white !important;
      color: var(--primary) !important;
    }
  }
}
</style>
